(function () {
  var DESKTOP_QUERY = '(min-width: 990px)';

  function isStickyEnabled(sticky) {
    return sticky.dataset.stickyDesktop === 'true' || sticky.dataset.stickyMobile === 'true';
  }

  function isFixedForViewport(sticky, desktopMedia) {
    return desktopMedia.matches
      ? sticky.dataset.stickyDesktop === 'true'
      : sticky.dataset.stickyMobile === 'true';
  }

  function getAnnouncementSection() {
    var bar = document.querySelector('.announcement-bar');
    return bar ? bar.closest('.shopify-section') : null;
  }

  function getAnnouncementHeight() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return 0;
    return bar.offsetHeight || 0;
  }

  function syncStickyHeaderLayout(sticky) {
    if (!sticky || !isStickyEnabled(sticky)) return;

    var section = sticky.closest('.shopify-section');
    if (!section) return;

    var announcementSection = getAnnouncementSection();
    var desktopMedia = window.matchMedia(DESKTOP_QUERY);
    var isFixed = isFixedForViewport(sticky, desktopMedia);
    var announcementHeight = isFixed ? getAnnouncementHeight() : 0;

    section.classList.toggle('custom-header--fixed', isFixed);

    if (announcementSection) {
      announcementSection.classList.toggle('custom-header--announcement-fixed', isFixed);
    }

    if (!isFixed) {
      document.documentElement.style.removeProperty('--header-fixed-top');
      document.documentElement.style.removeProperty('--header-height');
      document.documentElement.style.removeProperty('--announcement-bar-height');
      return;
    }

    document.documentElement.style.setProperty('--announcement-bar-height', announcementHeight + 'px');
    document.documentElement.style.setProperty('--header-height', sticky.offsetHeight + 'px');
    document.documentElement.style.setProperty('--header-fixed-top', announcementHeight + 'px');
  }

  function bindMediaQueryListener(mql, handler) {
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(handler);
    }
  }

  function unbindMediaQueryListener(mql, handler) {
    if (typeof mql.removeEventListener === 'function') {
      mql.removeEventListener('change', handler);
    } else if (typeof mql.removeListener === 'function') {
      mql.removeListener(handler);
    }
  }

  function bindLayoutListeners(sticky, handler) {
    var desktopMedia = window.matchMedia(DESKTOP_QUERY);
    bindMediaQueryListener(desktopMedia, handler);
    window.addEventListener('resize', handler, { passive: true });
    return desktopMedia;
  }

  function unbindLayoutListeners(desktopMedia, handler) {
    unbindMediaQueryListener(desktopMedia, handler);
    window.removeEventListener('resize', handler);
  }

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      if (!isStickyEnabled(this)) return;

      this._onLayoutChange = syncStickyHeaderLayout.bind(null, this);
      this._desktopMedia = bindLayoutListeners(this, this._onLayoutChange);
      syncStickyHeaderLayout(this);
    }

    disconnectedCallback() {
      if (!this._onLayoutChange || !this._desktopMedia) return;
      unbindLayoutListeners(this._desktopMedia, this._onLayoutChange);
    }
  }

  window.syncStickyHeaderLayout = syncStickyHeaderLayout;

  if (typeof customElements !== 'undefined' && customElements.define && !customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  document.querySelectorAll('sticky-header').forEach(function (sticky) {
    syncStickyHeaderLayout(sticky);
  });
})();
